// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#inspection-reservation-edit[data-v-4cd6c992]{max-width:700px;margin-left:auto;margin-right:auto}#inspection-reservation-edit .approved-name[data-v-4cd6c992]{height:27px;margin-bottom:4px;font-size:18px;font-weight:700}#inspection-reservation-edit .cancel-btn[data-v-4cd6c992],#inspection-reservation-edit .update-btn[data-v-4cd6c992]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
